// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".core-bce-passport-agreement-a55eb{bottom:24px;color:#84868c;font-size:12px;left:0;position:absolute;text-align:center;width:100%}.core-bce-passport-agreement-a55eb a{color:#2468f2}.core-bce-passport-agreement-a55eb a:hover{color:#528eff}.core-up-right-corner-04f20{background-image:url(https://bce.bdstatic.com/eop-plat/assets/img/login/reg-subscript.png);background-size:cover;box-sizing:border-box;color:#fff;cursor:pointer;font-size:14px;line-height:33px;padding:0 16px 0 36px;position:absolute;right:0;top:0;width:80px}.core-up-right-corner-04f20:hover{color:#a8caff}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bce-passport-agreement": "core-bce-passport-agreement-a55eb",
	"bcePassportAgreement": "core-bce-passport-agreement-a55eb",
	"up-right-corner": "core-up-right-corner-04f20",
	"upRightCorner": "core-up-right-corner-04f20"
};
export default ___CSS_LOADER_EXPORT___;
